export class ListItem {
    public text: string;
    public value: string | number;
}
